import { Component, Vue, Watch } from "vue-property-decorator";
import {
    WeightUnit,
    QualityStandard,
    CropList,
    selectedHarvestResultItems,
    HarvestResultMonthlyDetails,
} from "@/types/Component";
import {
    QualityStandardResponse,
    WeightUnitResponse,
} from "@/types/APIResponse";
import { toCamel } from "snake-camel";
import VerticalBarChart from "@/assets/common/VerticalBarChart/VerticalBarChart.vue";
import moment from "moment";
import { CsvDownload } from "@/types/APIResponse";
import EmptyGraphMessage from '@/assets/common/AggregationFunction/EmptyGraphMessage/EmptyGraphMessage.vue';


type QualityStandards = {
    qualityStandards: QualityStandard[];
};

type WeightUnits = {
    weightUnits: WeightUnit[];
};
interface Planting {
    id: number;  
}
@Component({
    components: {
        VerticalBarChart,
        EmptyGraphMessage,
    },
})
export default class HarvestResultByMonth extends Vue {
    title = "収穫実績（月別）";
    baseUrl = "/harvest_result_monthly";
    selectScreenManagement = "/graphScreenManagement";
    private qualityStandards: QualityStandard[] = [];
    private weightUnits: WeightUnit[] = [];
    private cropList = [] as CropList;
    private selectedCropId = null;
    private selectedQualityStandardId = null;
    private selectedWeightUnitId = null;
    private currentYear: any = "";
    private pastYear: any = "";
    private futureYear: any = "";
    private startDateInput: any = "";
    private endDateInput: any = "";
    private startDate: any = "";
    private endDate: any = "";
    private getSystemDate = new Date();
    private selectedYearQuantityArr: any[] = [];
    private previousYearQuantityArr: any[] = [];
    private unitType:any = null;
    private selectedCropName: any = "";
    private selectedWeightunitName: any = "";
    private selectedAgriFieldName: any = "";
    private selectedQualityName: any = "";
    private selectUnit = false;
    private maxQuantity: any = null;
    private selectedHarvestResultItems = {} as selectedHarvestResultItems;
    harvestResultMonthlyDetails = [] as HarvestResultMonthlyDetails;
    private monthsArr: any = [];
    private dataset1: any = [];
    private dataset2: any = [];
    private monthsArray: any[] = [];
    private selectedYearQuantity: any = [];
    private previousYearQuantity: any = [];
    private weightUnitName = "";
    private chartData: any = {};
    private options: any = {};
    private dataEmptyFlag = false;
    private cropsList=[]
    private plantingOrCropList=[] as any[]
    private selectedPlantingsOrCrops = 0
    private agriFields = [] as any[];
    private plantingsList = [] as any[];
    private lastYearPantingList =[] as any[];
    selectedCropOrPlantingId : string | null = null;
    private selectedAgriFieldId : string | null = null;
    private selectedLastYearPlantingId = null
    private plantingsOrCrops = [] as any[];
    private lastSetOption = false;
    private plantings = [];
    private crops = [];
    private harvestPlantings =[] as any[];
    selectedCropOrPlantingsId : string | null = null;
    private selectedPlantingOrCropName: any = "";
    private selectedLastYearPlantingName: any = "";
    errorMessage = false;
    includeHiddenFlag = false;

    created() {
        this.getWeightUnits();
        this.currentYear = this.getSystemDate.getFullYear();
        this.pastYear = this.getSystemDate.getFullYear() - 1;
        this.startDateInput = this.currentYear + "-01";
        this.endDateInput = this.currentYear + "-12";
        this.startDate = this.startDateInput;
        this.endDate = this.endDateInput;
        this.getHarvestResultbyMonth();
        this.getQualityStandards();
        this.getAgriFields()
        this.getCrops();
        this.getPlantings();
        this.getPlantingList();
        this.dataEmptyFlag = true;
    }

    //get dropdwonlist details 
     getQualityStandards() {
        this.$apiClient
            .doRequest("get", "/quality_standards?with_hidden=true")
            .then((res: QualityStandardResponse) => {
                this.qualityStandards = (toCamel(
                    res
                ) as QualityStandards).qualityStandards;
            })
            .catch(() => {
                this.$toasted.error("データの取得に失敗しました。");
            });
    }

     getWeightUnits() {
        this.$apiClient
            .doRequest("get", "/weight_units?with_hidden=true")
            .then((res: WeightUnitResponse) => {
                this.weightUnits = (toCamel(res) as WeightUnits).weightUnits;
            })
            .catch(() => {
                this.$toasted.error("データの取得に失敗しました。");
            });
    }

    getCrops() {
        this.$apiClient.doRequest("get", `/crops/cropBytenentId`).then(res => {
            this.cropsList = res.crops;
            this.cropsList.sort((a:any, b:any) => a.name.localeCompare(b.name));
            this.plantingOrCropList = !this.selectedPlantingsOrCrops ? this.plantingsList : this.cropsList
            this.selectedPlantingOrCropName= this.plantingOrCropList.find(item=>item.id==this.selectedCropOrPlantingsId)?.name
        });
    }

    getPlantings(){
        this.$apiClient.doRequest('get','/plantings?with_hidden=true').then((res) => {
        this.plantingsList = res.plantings.sort((a:any,b:any) => a.name.localeCompare(b.name));
          this.plantingOrCropList = !this.selectedPlantingsOrCrops ? this.plantingsList : this.cropsList
        });
    }

    getAgriFields() {
        this.$apiClient.doRequest('get', '/agri_fields?with_hidden=true').then((res) => {
            this.agriFields = res.agri_fields
        })        
    }
    // get dropdwonlist details 

    // filter functionality for harvest result by month screen
    handleSelectChange(flag = true) {
        this.selectedPlantingOrCropName= this.plantingOrCropList.find(item=>item.id==this.selectedCropOrPlantingsId)?.name
        this.selectUnit = this.selectedWeightUnitId != null || this.unitType == "" ? true : false;
        const momentStartDate = moment(this.startDateInput);
        const momentEndDate = moment(this.endDateInput);
        const firstDayOfMonth = momentStartDate.startOf("month").format("YYYY-MM-DD");
        const lastDayOfMonth = momentEndDate.endOf("month").format("YYYY-MM-DD");

        if(this.selectedCropOrPlantingsId == null){
            this.selectedLastYearPlantingId = null;
        }
        
        const params = {
            cropId: this.selectedPlantingsOrCrops ? this.selectedCropOrPlantingsId : null,
            plantingId: !this.selectedPlantingsOrCrops ? this.selectedCropOrPlantingsId : null,
            lastYearPlantingId:this.selectedLastYearPlantingId,
            agriFieldId: this.selectedAgriFieldId,
            startDate: firstDayOfMonth,
            endDate: lastDayOfMonth,
            maximumQuantity: this.maxQuantity,
            qualityStandardId: this.selectedQualityStandardId,
            weightUnitId: this.selectedWeightUnitId,
            screenName: "HARVESTRESULTBYMONTH",
            includeHiddenFlag: this.includeHiddenFlag
        };
        this.$apiClient.doRequest("post", `${this.selectScreenManagement}`, params).then((ret) => {
            if (flag) {
                this.getHarvestResultbyMonth();
            }
        });
    }

    handlePlantingsCropSelect () {
        this.plantingOrCropList = !this.selectedPlantingsOrCrops ? this.plantings : this.cropList
        this.selectedCropOrPlantingsId = null
        this.selectedLastYearPlantingId = null
        this.lastSetOption = this.selectedPlantingsOrCrops ? true : false;
        this.handleSelectChange();
        this.getCrops();
        this.getPlantings();
    }
    
    // lastYearPlantingCheck(){
    //     const momentStartDate = moment(this.startDateInput);
    //     const momentEndDate = moment(this.endDateInput);
    //     const firstDayOfMonth = momentStartDate.startOf("month").format("YYYY-MM-DD");
    //     const lastDayOfMonth = momentEndDate.endOf("month").format("YYYY-MM-DD");
    //     if(this.selectedLastYearPlantingId!=null){
    //         const matchingPlanting = this.plantingsList.find((planting: Planting) => planting.id === this.selectedLastYearPlantingId);
    //         // Parse dates from strings
    //         const workStartDate = new Date(matchingPlanting.work_start_date);
    //         const workEndDate = new Date(matchingPlanting.work_end_date);
    //         const displayStartDate = new Date(firstDayOfMonth); // Assuming firstDayOfMonth is already defined
    //         const displayEndDate = new Date(lastDayOfMonth); // Assuming lastDayOfMonth is already defined

    //         if (
    //             workStartDate.getFullYear() === displayStartDate.getFullYear() - 1 &&
    //             workEndDate.getFullYear() === displayStartDate.getFullYear() - 1
    //         ) {                
    //             this.errorMessage = false;
    //             this.handleSelectChange();
    //         } else {
    //             this.errorMessage = true;
    //         }
    //     }else{
    //         this.errorMessage = false;
    //         this.handleSelectChange();
    //     }
    // }

    // get HarvestResultByMonth details
    public getHarvestResultbyMonth() {
        this.harvestResultMonthlyDetails = []
        this.$apiClient.doRequest("get", `${this.baseUrl}?selected_planting_or_crop=${this.selectedPlantingsOrCrops}`).then((res) => {
            if(res.selectedItems){
                this.selectedHarvestResultItems = res?.selectedItems;
                this.defaultHarvestSelectItems(this.selectedHarvestResultItems);
                }
            if (!res.weightUnitNullCheck) {
                if(res.monthlyQuantity){
                this.unitType = this.selectedWeightUnitId ? "" : null;
                this.selectUnit = this.selectedWeightUnitId !=null ? true : false;
                this.harvestResultMonthlyDetails = res.monthlyQuantity;
                this.chartDataMapFunction(this.harvestResultMonthlyDetails)
                }
                if(res.monthlyQuantity.length === 0){
                    this.dataEmptyFlag = false;
                }
            }
            else{
                this.weightUnitName =this.weightUnits.find((item: any) =>item.id === this.selectedWeightUnitId)?.name || "kg";
                this.unitType = this.selectedWeightUnitId ? '' : null;
                this.selectUnit = this.selectedWeightUnitId !== null;
                window.alert("1単位あたりの重量を設定してください。");
              }
        });
    }

    // To select default item in harvest result by month screen
    private defaultHarvestSelectItems(selectedHarvestResultItems: any) {
            const startDateObject = new Date(selectedHarvestResultItems.displayFromDate?selectedHarvestResultItems.displayFromDate:this.startDateInput);
            const endDateObject = new Date(selectedHarvestResultItems.displayToDate?selectedHarvestResultItems.displayToDate:this.endDateInput);
            const formattedStartDate = startDateObject.toISOString().slice(0, 7);
            const formattedendDate = endDateObject.toISOString().slice(0, 7);
            this.selectedWeightUnitId = selectedHarvestResultItems.weightUnitId;
            this.weightUnitName = selectedHarvestResultItems.weightUnitName;
            this.selectedQualityStandardId = selectedHarvestResultItems.qualityStandardId;
            this.plantingOrCropList = selectedHarvestResultItems.cropId ||this.lastSetOption ?  this.cropsList : this.plantingsList; 
            this.selectedPlantingsOrCrops = selectedHarvestResultItems.cropId || this.lastSetOption ? 1 : 0;
            this.selectedCropOrPlantingsId = selectedHarvestResultItems.cropId ? selectedHarvestResultItems.cropId : selectedHarvestResultItems.plantingId
            this.selectedLastYearPlantingId = selectedHarvestResultItems.lastYearPlantingId;
            this.selectedAgriFieldId = selectedHarvestResultItems.agriFieldId;
            this.startDateInput = formattedStartDate;
            this.endDateInput = formattedendDate;
            this.maxQuantity = selectedHarvestResultItems.maximumQuantity;
            this.currentYear = Number(this.startDateInput.split("-")[0]);
            this.pastYear = Number(this.startDateInput.split("-")[0] - 1);
            this.futureYear = Number(this.endDateInput.split("-")[0]);
            this.includeHiddenFlag = selectedHarvestResultItems.includeHiddenFlag
    }

    private disableUnitselect(flag: boolean) {
        if (flag === true) {
            this.selectUnit = true;
        } else {
            this.selectedWeightUnitId = null;
            this.handleSelectChange();
            this.selectUnit = false;
        }
    }

    // Move the date range forward
    private moveForward() {
        const inputStartDate = new Date(this.startDateInput + "-01");
        const inputendDate = new Date(this.endDateInput + "-01");
        inputStartDate.setFullYear(inputStartDate.getFullYear() + 1);
        inputendDate.setFullYear(inputendDate.getFullYear() + 1);
        this.startDateInput = inputStartDate.toISOString().slice(0, 7);
        this.endDateInput = inputendDate.toISOString().slice(0, 7);
        this.handleSelectChange();
    }

    // Move the date range backward by one month
    private moveBackward() {
        const inputStartDate = new Date(this.startDateInput + "-01");
        const inputendDate = new Date(this.endDateInput + "-01");
        inputStartDate.setFullYear(inputStartDate.getFullYear() - 1);
        inputendDate.setFullYear(inputendDate.getFullYear() - 1);
        this.startDateInput = inputStartDate.toISOString().slice(0, 7);
        this.endDateInput = inputendDate.toISOString().slice(0, 7);
        this.handleSelectChange();
    }

    //start date validation 
    validateStartDates() {
        const startDate = new Date(this.startDateInput);
        startDate.setMonth(startDate.getMonth() + 11);
        const year = startDate.getFullYear();
        const month = (startDate.getMonth() + 1).toString().padStart(2, "0");
        const endDateValue = `${year}-${month}`;
        this.endDateInput = endDateValue;
        this.selectedLastYearPlantingId = null;
        this.handleSelectChange();
    }

    //end date validation 
    validateEndDates() {
        const endDate = new Date(this.endDateInput);
        endDate.setMonth(endDate.getMonth() - 11);
        const year = endDate.getFullYear();
        const month = (endDate.getMonth() + 1).toString().padStart(2, "0");
        const startDateValue = `${year}-${month}`;
        this.startDateInput = startDateValue;
        this.selectedLastYearPlantingId = null;
        this.handleSelectChange();

    }

    // validate maximum quantity
    private quantityValidate() {
        const maxQuantity = Math.max(
            ...this.selectedYearQuantityArr.concat(this.previousYearQuantityArr)
        );
        if (this.maxQuantity.toString().length > 10) {
            window.alert("「最大10桁までの数量を入力してください。」");
            this.maxQuantity = null;
        } else if (maxQuantity > this.maxQuantity && this.maxQuantity != "") {
            window.alert("「目盛の最大数量より小さいです。」");
            this.maxQuantity = null;
        } else {
            this.handleSelectChange();
        }
    }

    // Mapping and push data for chart details
    private chartDataMapFunction(harvestResultMonthlyDetails: any) {
        this.dataset1 = harvestResultMonthlyDetails.filter((item: any) =>new Date(item.month).getFullYear() === this.currentYear)
            .map((item: any) => ({month: item.month.split("-")[1],monthlyHarvestQuantity: item.monthlyHarvestQuantity,
            }));
        this.dataset2 = harvestResultMonthlyDetails.filter((item: any) =>new Date(item.month).getFullYear() === this.pastYear)
            .map((item: any) => ({
                month: item.month.split("-")[1],
                monthlyHarvestQuantity: item.monthlyHarvestQuantity,
            }));
        const monthDataProcess = harvestResultMonthlyDetails.map((item: any) => {
                const startDate = new Date(this.startDateInput);
                const endDate = new Date(this.endDateInput);
                const startMonth = startDate.getMonth() + 1;
                const endMonth = endDate.getMonth() + 1;
                const startIndex = startMonth ? startMonth : 1;
                const endIndex = endMonth ? endMonth : 12;
                const selectedYearQuantity = [];
                const previousYearQuantity = [];

                const monthArr = [];
                //If Different Period of Year Selected
                if (startDate.getFullYear() != endDate.getFullYear()) {
                    const selectedYear = startDate.getFullYear();
                    const previousYear = startDate.getFullYear() - 1;
                    const futureYear = startDate.getFullYear() + 1;
                    //get month of startYear
                    for (let i = startIndex; i <= 12; i++) {
                        const month = i.toString().padStart(2, "0");
                        const previousMonthData = this.harvestResultMonthlyDetails.find((item) => item.month === `${previousYear}-${month}`);
                        previousYearQuantity.push(previousMonthData? Number(previousMonthData.monthlyHarvestQuantity): 0);
                        const selectedMonthData = this.harvestResultMonthlyDetails.find((item) => item.month === `${selectedYear}-${month}`);
                        selectedYearQuantity.push(selectedMonthData? Number(selectedMonthData.monthlyHarvestQuantity): 0);
                        monthArr.push(i);
                    }
                    //get months of endYear
                    for (let i = 1; i <= endIndex; i++) {
                        const month = i.toString().padStart(2, "0");
                        const previousMonthData = this.harvestResultMonthlyDetails.find((item) => item.month === `${selectedYear}-${month}`);
                        previousYearQuantity.push(previousMonthData? Number(previousMonthData.monthlyHarvestQuantity): 0);
                        const selectedMonthData = this.harvestResultMonthlyDetails.find((item) => item.month === `${futureYear}-${month}`);
                        selectedYearQuantity.push(selectedMonthData? Number(selectedMonthData.monthlyHarvestQuantity): 0);
                        monthArr.push(i);
                    }
                    // same periods of year
                } else {
                    const selectedYear = startDate.getFullYear();
                    const previousYear = startDate.getFullYear() - 1;
                    for (let i = startIndex; i <= endIndex; i++) {
                        const month = i.toString().padStart(2, "0");
                        const selectedMonthData = this.harvestResultMonthlyDetails.find(
                            (item) => item.month === `${selectedYear}-${month}`
                        );
                        const previousMonthData = this.harvestResultMonthlyDetails.find(
                            (item) => item.month === `${previousYear}-${month}`
                        );
                        selectedYearQuantity.push(
                            selectedMonthData
                                ? Number(
                                      selectedMonthData.monthlyHarvestQuantity
                                  )
                                : 0
                        );
                        previousYearQuantity.push(
                            previousMonthData
                                ? Number(
                                      previousMonthData.monthlyHarvestQuantity
                                  )
                                : 0
                        );
                        monthArr.push(i);
                    }
                }
                this.selectedYearQuantityArr = selectedYearQuantity;
                this.previousYearQuantityArr = previousYearQuantity;
                this.monthsArray = monthArr;
            }
        );
        this.dataEmptyFlag = true;
        this.setChartDatas();
    }

    // roundUp value for graph shown
    private roundUpNumber(num: number): number {
        const stringValue = num.toString();
        const restOfTheNumber = parseInt(stringValue.substring(2));
        if (restOfTheNumber === 0) {
            return num;
        }
        const roundedNum =
            Math.pow(10, Math.floor(Math.log10(num))) *
            Math.ceil(num / Math.pow(10, Math.floor(Math.log10(num))));
        if (roundedNum === num) {
            return num;
        }
        return roundedNum;
    }

    // set chart data details function
    private setChartDatas(): void {
        const maxQunatity =
            Math.max(
                ...this.selectedYearQuantityArr.concat(
                    this.previousYearQuantityArr
                )
            ) * 1.2;
        const roundedmaxQuantity = this.roundUpNumber(maxQunatity);
        const startDate = new Date(this.startDateInput);
        const endDate = new Date(this.endDateInput);
        this.chartData = {
            labels: this.monthsArray,
            datasets: [
                {
                    label:
                        startDate.getFullYear() == endDate.getFullYear()
                            ? this.pastYear + "年"
                            : this.pastYear +
                              "年" +
                              "-" +
                              this.currentYear +
                              "年",
                    type: "line",
                    borderColor: "#FF6E53",
                    borderWidth: 2,
                    lineTension: 0,
                    fill: false,
                    data: this.previousYearQuantityArr,
                },
                {
                    type: "bar",
                    label:
                        startDate.getFullYear() == endDate.getFullYear()
                            ? this.currentYear + "年"
                            : this.currentYear +
                              "年" +
                              "-" +
                              this.futureYear +
                              "年",
                    borderColor: "#71A0D8",
                    backgroundColor: "#71A0D8",
                    data: this.selectedYearQuantityArr,
                    barPercentage: 0.4,
                },
            ],
        };
        this.options = {
            responsive: true,
            maintainAspectRatio: false,
            tooltips: {
                callbacks:{
                    title:function(tooltipItem:any,data:any){
                        return data.datasets[tooltipItem[0].datasetIndex].label +" "+tooltipItem[0].label+"月"
                    },
                    label: (tooltipItem: any, data: any)=>{
                      const quantity = Number(tooltipItem.value)
                      return quantity.toLocaleString('ja-JP') + this.weightUnitName
                    }
                  }
                },
            scales: {
                xAxes: [
                    {
                        ticks: {
                            callback: (value: any) => {
                                return value + "月";
                            },
                        },
                    },
                ],
                yAxes: [
                    {
                        ticks: {
                            beginAtZero: true,
                            suggestedMax:
                                this.maxQuantity == null
                                    ? roundedmaxQuantity
                                    : this.maxQuantity,
                            stepSize:
                                this.maxQuantity == null
                                    ? Math.round(roundedmaxQuantity / 5)
                                    : Math.round(this.maxQuantity / 5),
                            callback: (value: any) => {
                                return (
                                    value.toLocaleString("ja-JP") +"  "+ ( this.weightUnitName.length > 10 ? this.weightUnitName.substring(0,7) + "..." : this.weightUnitName)
                                );
                            },
                        },
                    },
                ],
            },
            legend: {
                position: "bottom",
            },
            layout: {
                padding: {
                    left: 20,
                    right: 20,
                    top: 20,
                    bottom: 0,
                },
            },
        };
    }

    // csv export for 収穫実績（月別）
    exportCsv() {
        this.selectedQualityName = this.qualityStandards.find((item) => item.id === this.selectedQualityStandardId)?.name;
        this.selectedWeightunitName = this.weightUnits.find((item) => item.id === this.selectedWeightUnitId)?.name;
        this.selectedAgriFieldName = this.agriFields.find((item) => item.id === this.selectedAgriFieldId)?.name;
        this.selectedPlantingOrCropName= this.plantingOrCropList.find(item=>item.id==this.selectedCropOrPlantingsId)?.name
        this.selectedLastYearPlantingName = this.plantingsList.find((item) => item.id === this.selectedLastYearPlantingId)?.name;
        this.$apiClient.getRequest(`${this.baseUrl}/csv_export?selected_planting_or_crop=${this.selectedPlantingsOrCrops}&start_date=${this.startDateInput}&end_date=${this.endDateInput}&agri_fields=${this.selectedAgriFieldName?this.selectedAgriFieldName:""}&quality_standard=${this.selectedQualityName || ""}&crop_or_planting=${this.selectedPlantingOrCropName?this.selectedPlantingOrCropName:""}&last_year_planting=${this.selectedLastYearPlantingName?this.selectedLastYearPlantingName:""}&units=${this.selectedWeightunitName || ""}`)
        .then((res: CsvDownload) => {this.$apiClient.csvDownload(res);
        });
    }

    get filterQualityStandards() {
        return this.includeHiddenFlag ? this.qualityStandards : this.qualityStandards.filter(qs => this.selectedQualityStandardId == qs.id || !qs.isHidden);
    }

    get filterWeightUnits() {
        return this.includeHiddenFlag ? this.weightUnits : this.weightUnits.filter(wu => this.selectedWeightUnitId == wu.id || !wu.isHidden);
    }

    get filterPlantingOrCropList() {
        if (this.selectedPlantingsOrCrops) {
          return this.plantingOrCropList
        } else {
          return this.includeHiddenFlag ? this.plantingOrCropList : this.plantingOrCropList.filter(p => this.selectedCropOrPlantingsId == p.id || !p.is_hidden);
        }
    }

    // get filterPlantingList(){
    //     const plantingCropIDetails = this.plantingOrCropList.filter(item => item.id == this.selectedCropOrPlantingsId);
    //     if (plantingCropIDetails.length > 0) {
    //     const plantingStartDate = plantingCropIDetails[0].work_start_date;
    //     const date = new Date(plantingStartDate);
    //     date.setMonth(date.getMonth() - 13);
    //     date.setDate(1)
    //     const startDate = date.toLocaleDateString();
    //     date.setMonth(date.getMonth()+14)
    //     date.setDate(date.getDate()-1)
    //     const endDate = date.toLocaleDateString();

    //     const plantingCropId = plantingCropIDetails[0]?.crop.id;
    //     this.$apiClient.doRequest("get", `${this.baseUrl}/planting_list?start_date=${startDate}&&end_date=${endDate}&&crop_id=${plantingCropId}`).then((res) => {
    //     this.harvestPlantings = res.harvestPlantings
    //     return this.lastYearPantingList = this.plantingOrCropList.filter(item1 => this.harvestPlantings.some(item2 => item1.id === item2.plantingId));
        
    //  });

    //     return  this.includeHiddenFlag ? this.lastYearPantingList.filter(p => this.selectedCropOrPlantingsId != p.id) : this.lastYearPantingList.filter(p => this.selectedCropOrPlantingsId != p.id && !p.is_hidden);
    // }
    // }
    
    getPlantingList(){
    this.validatePlanting();
    }

    handlechangeplanting(){
        this.selectedLastYearPlantingId = null;
        this.validatePlanting();
        this.handleSelectChange();
    }

    validatePlanting(){
        setTimeout(() => {
            const plantingCropIDetails = this.plantingOrCropList.filter(item => item.id == this.selectedCropOrPlantingsId);
            if (plantingCropIDetails.length > 0) {
                    const plantingStartDate = plantingCropIDetails[0].work_start_date;
                    const date = new Date(plantingStartDate);
                    date.setMonth(date.getMonth() - 13);
                    date.setDate(1)
                    const startDate = date.toISOString().split('T')[0];
                    date.setMonth(date.getMonth()+14)
                    date.setDate(date.getDate()-1)
                    const endDate = date.toISOString().split('T')[0];
                
                    const plantingCropId = plantingCropIDetails[0]?.crop.id;
                    this.$apiClient.doRequest("get", `${this.baseUrl}/planting_list?start_date=${startDate}&&end_date=${endDate}&&crop_id=${plantingCropId}`).then((res) => {
                    this.harvestPlantings = res.harvestPlantings  
                    this.harvestPlantings = this.harvestPlantings.filter(p => this.selectedCropOrPlantingsId != p.plantingId)
                    if(this.harvestPlantings.length==1){
                        this.selectedLastYearPlantingId = this.harvestPlantings[0].plantingId;
                    }
                    if(this.harvestPlantings.filter(p => this.selectedLastYearPlantingId == p.plantingId).length==0){
                        this.selectedLastYearPlantingId = null;
                    }
                    });
              }
            }, 200);
    }

    get filterAgriFields(){
        return this.includeHiddenFlag ? this.agriFields : this.agriFields.filter(a => this.selectedAgriFieldId == a.id || !a.is_hidden);
    } 
}